import React, { useEffect, useState } from 'react'
import { Avatar, Box, Button, Divider, FormControl, FormHelperText, IconButton, InputLabel, MenuItem, Select, Step, StepConnector, StepIconProps, StepLabel, Stepper, stepConnectorClasses, TextField, Typography, Dialog, DialogContent } from '@mui/material'
import { CancelOutlined, Check, Info, InfoOutlined, KeyboardArrowLeft, KeyboardArrowRight, Padding, SelectAllOutlined, WestOutlined } from '@mui/icons-material';
import { ErrorMessage, Formik, Form, useFormikContext, useFormik } from 'formik';
import dayjs, { Dayjs } from 'dayjs';
import { ApiApplyBundleAllocations, ApiApplyTransportBundle, ApiBundleAllocations, ApiGetAllocationCriteriaDetails, ApiGetNewBrief, ApiGetQuiz, APiGetTimeSelection, ApiSubmitQuiz, applyTasks, fetchTransportBundle, getVisitTimes } from '../../../apiService/Core/Apicall.tsx';
import { data, useNavigate } from 'react-router-dom';
import sad from "../../../assets/Project_Images/sad (2).png";
import { DatePicker, LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import clsx from 'clsx';
import { findData, setData } from '../../../Redux/GetTimeSlice.tsx';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from "yup";
import { RootState } from '../../../Redux/Store';
import Loading from '../../Loader/Loading.tsx';
import { toast } from 'react-toastify';
import { styled } from '@mui/material/styles';
import minMax from "dayjs/plugin/minMax";
import ReadBrief from './ReadBrief.tsx';

dayjs.extend(minMax);


const ColorlibStepIconRoot = styled('div')<{
    ownerState: { active?: boolean; completed?: boolean };
}>(({ theme, ownerState }) => ({
    backgroundColor: ownerState.completed
        ? '#7C9FB2' // green for completed
        : ownerState.active
            ? '#BF613B' // blue for active
            : '#ccc', // grey for default
    zIndex: 1,
    color: '#fff',
    width: 32,
    height: 32,
    padding: 0,
    margin: 0,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
}));

function ColorlibStepIcon(props: StepIconProps) {
    const { active, completed, className, icon } = props;

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {icon}
        </ColorlibStepIconRoot>
    );
}

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 15,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundColor: '#BF613B', // color when active
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundColor: '#7C9FB2', // color when completed
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 5,
        margin: 0,
        Padding: 0,
        border: 0,
        backgroundColor: '#ccc', // default (inactive) color
        borderRadius: 1,
    },
}));

function BulkAllocation({ date, isTransport, selectedbundletask, setOpenPicker, setOpenFilter, setAlignment, openFilter, handlesaveFilter, formValues, reloadFlag, selectedentitytype, selectedstate, selectedClient, location }: any) {
    const [totalallocation, settotalallocation] = useState<any>([])
    const [selectedId, setSelectedId] = useState<any>(0);
    const [selectedmonth, setSelectedmonth] = useState<Dayjs>(date);
    const [activeStep, setActiveStep] = React.useState<any>(0);
    const [OpenDialog, setOpenDialog] = useState<boolean>(false);
    const [OpenNewBriefDialog, setOpenNewBriefDialog] = useState<boolean>(false);
    const [OpenNewBriefReadDialog, setOpenNewBriefReadDialog] = useState<boolean>(false);

    const navigate = useNavigate();
    const loading = useSelector((state: any) => state.loader.isLoading);

    const filtervalue = useSelector(
        (state: RootState) => state.counter.filterData
    );
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const dispatch = useDispatch();
    const [allocationCriteria, setAllocationCriteria] = useState<any>([]);
    const [SendData, setSendData] = useState<any>([]);
    const applyfilters: Record<string, any> = {};
    const [viewBrief, setViewBrief] = useState<any>(null)
    const [newBrief, setNewBrief] = useState<any>()
    const [QuizList, setQuizList] = useState<any[]>([])
    const [selectedOptions, setSelectedOptions] = useState<any>([]);
    const [OpenQuiz, setOpenQuiz] = useState<boolean>(false);
    const [IsQuizSubmitted, setIsQuizSubmitted] = useState<boolean>(false);
    const [quizType, setQuizType] = useState<any>()
    const [openInfo, setOpenInfo] = useState<boolean>(false)


    useEffect(() => {
        setSendData([])
        setActiveStep(0)

    }, [date, selectedId])



    useEffect(() => {
        // console.log('Active Task', totalallocation[selectedId]?.allocations[activeStep])
        const SetTimes = async () => {
            if ((totalallocation[selectedId]?.isNeedToSelectDate || !isTransport) && totalallocation?.length > 0) {
                // console.log("Active Step---->", totalallocation[selectedId || 0].allocations)
                // console.log("Selected Id ---->", selectedId)
                const item = {
                    allocationId: totalallocation[selectedId || 0]?.allocations[activeStep || 0] && totalallocation[selectedId || 0]?.allocations[activeStep || 0].allocationId,
                    clientEntityId: totalallocation[selectedId || 0]?.allocations[activeStep || 0] && totalallocation[selectedId || 0]?.allocations[activeStep || 0]?.venueId.clientEntityId?.clientEntityId,
                    userId: totalallocation[selectedId || 0]?.allocations[activeStep || 0] && userData?.userId,
                }
                const data = `?allocationId=${item?.allocationId}&clientEntityId=${item?.clientEntityId}&userId=${userData?.userId}`;
                const response = item?.allocationId && item?.clientEntityId && item?.userId && await ApiGetAllocationCriteriaDetails(data);
                setAllocationCriteria(response?.data)


                const locationType = totalallocation[selectedId]?.allocations[activeStep]?.venueId?.locationType;
                const visitTimeArray =
                    // locationType === "region"
                    //     ? response?.data?.regionVisitTimeInformation?.split(",").map(Number)
                    //     : 
                    totalallocation[selectedId]?.allocations[activeStep]?.visitTimeInformation?.split(",").map(Number);
                // dispatch(

                //     findData(
                //         totalallocation[selectedId]?.allocations[activeStep]?.visitTimeInformation
                //             ?.split(",")
                //             .map(Number)
                //     )
                // )
                dispatch(

                    findData(
                        visitTimeArray
                    )
                )
            } else {
                dispatch(
                    findData(
                        totalallocation[selectedId]?.bundleVisitTimeInformation
                            ?.split(",")
                            .map(Number)
                    )
                )
            }
        }
        SetTimes()
    }, [activeStep, selectedId, date, totalallocation])

    const fetchbundleallocation = async () => {

        const data = `
        ?isUseForRunningAllocation=true&userId=${userData.userId}&
        // jobMonth=${date.month() + 1}&
        // jobYear=${date.year()}`
        const data2 = `?month=${date.month() + 1}&year=${date.year()}&userId=${userData.userId}&allocationStatus=ongoing`
        try {
            applyfilters.isUseForRunningAllocation = true;
            applyfilters.jobYear = date.year();
            applyfilters.jobMonth = date.month() + 1;
            applyfilters.userId = userData.userId;
            if (formValues?.filterOption == "myHome" && !selectedstate) {
                Object.assign(applyfilters, {
                    nearByHome: true,
                    // nearBy: true,
                });
            }
            if (!selectedstate && (formValues?.filterOption == "nearMe" || formValues?.filterOption == "manual")) {
                Object.assign(applyfilters, {
                    // nearByHome: true,
                    nearBy: true,
                });
            }

            if (selectedentitytype) {
                applyfilters.entityTypeId = selectedentitytype
            }

            if (selectedstate) {
                applyfilters.state = selectedstate
            }
            if (selectedClient !== 'all') {
                applyfilters.allocationClientGroup = selectedClient
            }

            if (formValues?.venue?.length === 0 && !selectedstate) {
                applyfilters.kilometerRange = formValues?.range;
            }
            else if (formValues?.venue?.length > 0) {
                applyfilters.venueId = formValues?.venueId;
            }

            if (
                formValues?.filterOption === "nearMe" ||
                formValues?.filterOption === "manual"
            ) {
                Object.assign(applyfilters, {
                    latitude: location?.latitude,
                    longitude: location?.longitude,
                });
            }
            const response = isTransport ? await fetchTransportBundle(data2) : await ApiBundleAllocations(applyfilters)
            settotalallocation(response.data)
            setSelectedId(0)
            setActiveStep(0)
            setSendData([])
            console.log("Formik.values", formik.values)

            // formik.resetForm()
            if (response && openFilter) {
                handlesaveFilter()
            }
            fetchAllocationCriteria(response?.data?.[0]?.allocations[0])
        } catch (error: any) {
            const message =
                error?.response?.data?.message || // API error message
                error?.message ||                 // JS error message
                String(error);
            toast.error(message)
        }
    }
    useEffect(() => {
        fetchbundleallocation()
        setSelectedmonth(date)
    }, [date, reloadFlag])
    const fetchData = async () => {
        try {
            const response = await getVisitTimes();
            // console.log("Get Visited Time", response.data);

            dispatch(setData(response.data));
        } catch (error) {
            // console.error("Error fetching visit times:", error);
        }
    };
    useEffect(() => {
        fetchData();
    }, [dispatch]);

    const fetchAllocationCriteria = async (item: any) => {
        // console.log("Allocation Ci")
        setAllocationCriteria([])
        if (item?.allocationId && (item?.venueId?.clientEntityId?.clientEntityId || item?.clientEntityId?.clientEntityId)) {

            try {
                const data = `?allocationId=${item?.allocationId}&clientEntityId=${item?.venueId?.clientEntityId?.clientEntityId ?? item?.clientEntityId?.clientEntityId}&userId=${userData?.userId}`;
                const response = await ApiGetAllocationCriteriaDetails(data);
                if (response?.success) {
                    setAllocationCriteria(response.data);
                }
            } catch (error: any) {
                const message =
                    error?.response?.data?.message || // API error message
                    error?.message ||                 // JS error message
                    String(error);
                console.log(message)
            }

        }
    };

    const selectcard = async (index: number) => {
        // console.log(index);
        (totalallocation[index]?.isNeedToSelectDate || !isTransport) && await fetchAllocationCriteria(totalallocation[index]?.allocations[activeStep])
        setSelectedId(index);
        if (totalallocation[index]?.isNeedToSelectDate || !isTransport) {

            const locationType = totalallocation[index]?.allocations[activeStep]?.venueId?.locationType;
            const visitTimeArray =
                // locationType === "region"
                //     ? allocationCriteria?.regionVisitTimeInformation?.split(",").map(Number)
                //     : 
                totalallocation[index]?.allocations[activeStep]?.visitTimeInformation?.split(",").map(Number);
            // dispatch(
            //     findData(
            //         totalallocation[index]?.allocations[activeStep]?.visitTimeInformation
            //             ?.split(",")
            //             .map(Number)
            //     )
            // )
            dispatch(
                findData(
                    visitTimeArray
                )
            )

        } else {
            dispatch(
                findData(
                    totalallocation[index]?.bundleVisitTimeInformation
                        ?.split(",")
                        .map(Number)
                )
            )
        }
    };

    useEffect(() => {
        if (!selectedbundletask || !totalallocation) return;

        totalallocation?.some((item: any, index: number) => {
            const found = item?.allocations?.some(
                (alloc: any) => alloc?.allocationId == selectedbundletask
            );

            if (found) {
                selectcard(index);
                return true;
            }

            return false;
        });
    }, [selectedbundletask, totalallocation]);



    // console.log("Selected Index", selectedbundletask)
    // console.log("Total ALLocations", totalallocation[selectedId]?.allocations[activeStep])

    // useEffect(() => {
    //     totalallocation[selectedId]?.allocations[activeStep] && (totalallocation[selectedId]?.isNeedToSelectDate || !isTransport) && fetchAllocationCriteria(totalallocation[selectedId]?.allocations[activeStep])

    // }, [selectedId, activeStep])

    // const VisitDateResetter = ({ selectedmonth, selectedId, totalallocation }) => {
    //     const { setFieldValue } = useFormikContext();

    //     useEffect(() => {
    //         if (
    //             selectedmonth &&
    //             totalallocation[selectedId]?.allocations[activeStep]?.jobMonth &&
    //             selectedmonth.month() + 1 !== totalallocation[selectedId]?.allocations[activeStep]?.jobMonth
    //         ) {
    //             setFieldValue("selectedVisitDate", "");
    //         }
    //     }, [selectedmonth, selectedId]);

    //     return null;
    // };


    const steps = selectedId !== null ? (totalallocation[selectedId]?.isNeedToSelectDate == true || !isTransport) ? totalallocation[selectedId]?.allocations.map((allocation) => `${allocation?.venueId?.venueName}`) : [1] : [];
    // const currentAllocation = selectedId !== null ? totalallocation[selectedId]?.allocations[activeStep] : '';

    const shouldDisableDate = (
        date: Dayjs,
        activeMonth: any,
        activeYear: any,
        startDay: any,
        endDay: any,
        visitDaysString: string
    ) => {
        // Convert visitDaysInformation to an array
        const allowedDays = visitDaysString?.split(", ").map((day) => day?.trim());
        const formattedDate = date.format("YYYY-MM-DD");

        if (allocationCriteria?.holidayDates?.includes(formattedDate)) {
            return true;
        }

        if (
            allocationCriteria?.businessHolidays?.some(
                (holiday: any) => holiday?.date === formattedDate
            )
        ) {
            return true;
        }

        // Get full day name (e.g., "Monday")
        const dayName = date.format("dddd");

        // Disable if the day is NOT in the allowedDays array
        if (!allowedDays?.includes(dayName)) {
            return true;
        }

        // Disable dates outside the active month and year
        if (date.month() + 1 !== activeMonth || date.year() !== activeYear) {
            return true;
        }

        // Disable dates outside the given range
        if (date.date() < startDay || date.date() > endDay) {
            return true;
        }

        // Hide non-weekend days 
        if (allocationCriteria?.isNeedToHideNonWeekend) {
            const weekendDays = ["Saturday", "Sunday"];
            if (!weekendDays.includes(dayName)) {
                return true; // Disable Monday to Friday
            }
        }
        // Hide weekend days 
        if (allocationCriteria?.isNeedToHideWeekend) {
            const weekendDays = ["Saturday", "Sunday"];
            if (weekendDays.includes(dayName)) {
                return true; // Disable Monday to Friday
            }
        }

        if (
            allocationCriteria?.shouldBeDifferentDayFromPreviousMonth &&
            allocationCriteria?.lastJobVisitedDate
        ) {
            const lastVisitedDayName = dayjs(
                allocationCriteria.lastJobVisitedDate
            ).format("dddd"); // Get day name from last visited date
            if (dayName === lastVisitedDayName) {
                return true; // Block this date
            }
        }

        // New Condition ➡️ Block dates if less than minDaysGapBetweenJobs
        if (
            allocationCriteria?.minDaysGapBetweenJobs &&
            allocationCriteria?.lastJobVisitedDate
        ) {
            const gapRequired = allocationCriteria.minDaysGapBetweenJobs;
            const lastVisitDate = dayjs(allocationCriteria.lastJobVisitedDate);
            const minAllowedDate = lastVisitDate.add(gapRequired, "day"); // Add required gap

            if (date.isBefore(minAllowedDate, "day")) {
                return true; // Block dates before (lastVisitDate + gap days)
            }
        }

        // 🔹 Block dates between venueOpenMinus7Days and venueClosePlus3Days
        if (
            allocationCriteria?.venueOpenMinus7Days &&
            allocationCriteria?.venueClosePlus3Days
        ) {
            const date1 = dayjs(allocationCriteria.venueOpenMinus7Days);
            const date2 = dayjs(allocationCriteria.venueClosePlus3Days);

            if (!date1.isValid() || !date2.isValid()) {
                console.log("Invalid date");
                return false;
            }

            const start = date1.isBefore(date2) ? date1 : date2;
            const end = date1.isBefore(date2) ? date2 : date1;

            if (
                (date.isAfter(start, "day") && date.isBefore(end, "day")) ||
                date.isSame(start, "day") ||
                date.isSame(end, "day")
            ) {
                return true;
            }
        }
    };

    useEffect(() => {
        if (totalallocation?.data?.length > 0 && totalallocation[selectedId]?.allocations[activeStep]) {
            setSelectedId(window.innerWidth <= 576 ? null : 0);
            if (totalallocation[selectedId]?.isNeedToSelectDate || !isTransport) {
                const locationType = totalallocation[selectedId]?.allocations[activeStep]?.venueId?.locationType;
                const visitTimeArray =
                    // locationType === "region"
                    //     ? allocationCriteria?.regionVisitTimeInformation?.split(",").map(Number)
                    //     : 
                    totalallocation[selectedId]?.allocations[activeStep]?.visitTimeInformation?.split(",").map(Number);
                //  dispatch(
                //         findData(
                //             totalallocation[selectedId]?.allocations[activeStep]?.visitTimeInformation
                //                 ?.split(",")
                //                 .map(Number)
                //         )
                //     )
                dispatch(
                    findData(
                        visitTimeArray
                    )
                )
            } else {
                dispatch(
                    findData(
                        totalallocation[selectedId]?.bundleVisitTimeInformation
                            ?.split(",")
                            .map(Number)
                    )
                )
            }
            const data = {
                allocationId: totalallocation[selectedId]?.allocations[activeStep] && totalallocation[selectedId]?.allocations[activeStep].allocationId,
                clientEntityId: totalallocation[selectedId]?.allocations[activeStep] && totalallocation[selectedId]?.allocations[activeStep]?.venueId.clientEntityId?.clientEntityId,
                userId: totalallocation[selectedId]?.allocations[activeStep] && userData?.userId,
            }
            totalallocation[selectedId]?.allocations[activeStep] && (totalallocation[selectedId]?.isNeedToSelectDate || !isTransport) && fetchAllocationCriteria(data);
        }
    }, [totalallocation, activeStep]);

    const handlePrevMonth = () => {
        setSelectedmonth((prev) => prev.subtract(1, "month"));
    };

    const handleNextMonth = () => {
        setSelectedmonth((prev) => prev.add(1, "month"));
    };
    const initialValues = {
        allocationId: null,
        selectedVisitDate: "",
        selectedVisitTime: "",
        createdBy: userData.userId,
        bundleId: (totalallocation && selectedId) && totalallocation[selectedId]?.bundleId,

    }
    const validationSchema = Yup.object({
        selectedVisitDate: Yup.string().required("Select a Date"),
        selectedVisitTime: Yup.string().required("Select a Time"),
    });

    const onSubmit = async (values: any, { resetForm }: any) => {
        if (totalallocation[selectedId]?.isNeedToSelectDate || !isTransport) {
            if (!IsQuizSubmitted && allocationCriteria && allocationCriteria?.isQuizRequired) {
                await handleOpenQuiz(totalallocation[selectedId]?.allocations[activeStep]?.venueId?.clientEntityId?.clientEntityId, totalallocation[selectedId]?.allocations[activeStep]?.venueId?.venueId)
                return;
            }
            if (IsQuizSubmitted && allocationCriteria?.isQuizRequired) {
                const data = {
                    userId: userData?.userId,
                    type: quizType,
                    ...(quizType === "venue"
                        ? {
                            venueId: totalallocation[selectedId]?.allocations[activeStep]?.venueId?.venueId,
                        }
                        : {
                            clientEntityId:
                                totalallocation[selectedId]?.allocations[activeStep]?.venueId?.clientEntityId?.clientEntityId,
                        }),
                }
                await ApiSubmitQuiz(data)
            }
            const formattedValues = {
                ...values,
                bundleId: totalallocation[selectedId]?.bundleId,
                allocationId:
                    totalallocation[selectedId]?.allocations[activeStep]?.allocationId,
                selectedVisitDate: values.selectedVisitDate
                    ? dayjs(values.selectedVisitDate).format("YYYY-MM-DD")
                    : "",
            };
            const final_data = SendData
            const nextstep = activeStep + 1;
            setActiveStep(nextstep);
            setOpenNewBriefDialog(false)
            // console.log("Send Data", nextstep);
            const matchdata = final_data.findIndex((item: any) => item.allocationId == formattedValues.allocationId)
            // console.log("Match data", matchdata)

            if (matchdata != -1) {
                final_data[matchdata] = formattedValues
            }
            else {
                final_data.push(formattedValues)
            }
            // console.log("Formated Values", formattedValues);
            // console.log("Final Values", final_data);
            setSendData(final_data)
            if (final_data.length === totalallocation[selectedId]?.allocations.length) {

                const data = {
                    appliedAllocationJob: final_data
                }
                const data2 = {
                    type: "manuallySelect",
                    withoutVenueBundleAllocationId: totalallocation[selectedId]?.bundleId,
                    createdBy: userData?.userId,
                    allocations: final_data.map((item: any) => ({
                        allocationId: item.allocationId,
                        selectedVisitDate: item.selectedVisitDate,
                        selectedVisitTime: item.selectedVisitTime
                    }))
                }
                try {
                    const res = isTransport ? await ApiApplyTransportBundle(data2) : await ApiApplyBundleAllocations(data)
                    toast.success(res.message)
                    fetchbundleallocation()

                } catch (error) {
                    const message =
                        error?.response?.data?.message || // API error message
                        error?.message ||                 // JS error message
                        String(error);
                    toast.error(message)
                }
            }

            resetForm()

            final_data.map((item) => {
                if (item.allocationId == totalallocation[selectedId]?.allocations[nextstep]?.allocationId) {
                    formik.setFieldValue('selectedVisitDate', item.selectedVisitDate)
                    formik.setFieldValue('selectedVisitTime', item.selectedVisitTime)
                }

            })


        }
        else {
            const applytransportbundle = async () => {
                try {
                    const data = {
                        "withoutVenueBundleAllocationId": totalallocation[selectedId]?.bundleId,
                        "selectedVisitDate": values?.selectedVisitDate,
                        "selectedVisitTime": values?.selectedVisitTime,
                        "createdBy": values?.createdBy
                    }
                    const res = await ApiApplyTransportBundle(data)
                    if (res.status) {
                        fetchbundleallocation()
                        toast.success('You have successfully applied. Hold tight to find out if you are successful.')
                    }
                } catch (error: any) {
                    const message =
                        error?.response?.data?.message || // API error message
                        error?.message ||                 // JS error message
                        String(error);
                    toast.error(message)
                }
            }
            applytransportbundle()
        }
    }


    const formik = useFormik({
        initialValues,
        validationSchema,
        validateOnChange: true, // Ensures validation only happens on blur or submit
        validateOnBlur: false,
        onSubmit,
    });
    // console.log("Formik.values", formik.values)


    const handleBack = (backallocationId) => {
        const backstep = activeStep - 1;
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        SendData.map((item) => {
            if (item.allocationId == totalallocation[selectedId]?.allocations[backstep]?.allocationId) {
                formik.setFieldValue('selectedVisitDate', item?.selectedVisitDate)
                formik.setFieldValue('selectedVisitTime', item?.selectedVisitTime)
            }
        })
    };


    const handleCallAnotherCriteria = async (item: any, isNeedToHideWeekend: boolean, isNeedToHideNonWeekend: boolean) => {
        try {
            const data = `?allocationId=${item.allocationId}&venueId=${item?.venueId}&jobMonth=${item?.jobMonth}&jobYear=${item?.jobYear}&isWeekDayJob=${isNeedToHideWeekend}&isWeekendDayJob=${isNeedToHideNonWeekend}`
            const res = await APiGetTimeSelection(data)
            if (res?.status) {

                setTimeout(() => {
                    dispatch(
                        findData(
                            res?.visitTimeList?.map(Number)
                        )
                    );
                }, 100);
                // setDateCriteria(res?.data)
            }
        } catch (error) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                String(error);
            console.log(message)
        }
    }

    const handleDialogOpen = () => {
        setOpenDialog(true);
    };

    const handleDialogClose = () => {
        setOpenDialog(false);
        setViewBrief(null)
    };


    const getBrief = async (venueId: string, clientEntity: string) => {
        try {
            const data = `?venueId=${venueId}&clientEntityId=${clientEntity}`
            const res = await ApiGetNewBrief(data)
            if (res?.status || res?.success) {
                setNewBrief(res)
                return res;
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong")
        }
    }

    const handleReadBrief = async () => {
        try {
            const res = await getBrief(
                totalallocation[selectedId]?.allocations[activeStep]?.venueId?.venueId,
                totalallocation[selectedId]?.allocations[activeStep]?.venueId?.clientEntityId?.clientEntityId)
            setNewBrief(res)
            if (allocationCriteria?.isNewBriefSetup) {
                setOpenNewBriefReadDialog(true)
            }
            else {
                handleDialogOpen();
            }
        } catch (error) {
            console.log("Error", error)
        }
    }

    const shuffleArray = (array: any) => {
        const shuffled = [...array];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    };

    const handleOpenQuiz = async (clientEntityId: string, venueId: string, isOpen: boolean = false) => {
        const data = `?clientEntityId=${clientEntityId}&venueId=${venueId}`
        const response = await ApiGetQuiz(data)
        // setQuizList(response.data)
        setQuizType(response?.quizType)
        setQuizList(shuffleArray(response.data))
        // allocationCriteria && allocationCriteria?.isQuizRequired ? setOpenBriefDialog(true) : toast.success("Quiz is not required")
        if (allocationCriteria && allocationCriteria?.isQuizRequired) {
            if (allocationCriteria?.isNewBriefSetup) {
                // setOpenNewBriefDialog(true)
                isOpen ? setOpenInfo(true) : setOpenNewBriefDialog(true)
                setOpenQuiz(false)
            }
            else {
                setOpenQuiz(true)
                setOpenNewBriefDialog(false)
            }
        }
        else {
            if (allocationCriteria?.isNewBriefSetup) {
                setOpenDialog(false)
                // setOpenNewBriefDialog(true)
                isOpen ? setOpenInfo(true) : setOpenNewBriefDialog(true)
            }
            else {
                setOpenDialog(true)
                setOpenNewBriefDialog(false)
            }
        }
        setSelectedOptions([])
    }

    useEffect(() => {
        setSelectedOptions([])
        const newOptions = QuizList.map((item) => ({
            QuestionId: item.quiz_question_id,
            SelectedAnswer: null,
            answerIds: item.answerIds || ""
        }));
        setSelectedOptions((prevOptions: any) => [...prevOptions, ...newOptions]);
    }, [QuizList])

    return (
        <Box>
            <Box className='d-flex align-items-center gap-2'>

                {totalallocation.length > 0 ? (
                    <Box
                        className="d-flex  flex-column w-100 flex-lg-row"
                        minHeight={{ xs: "100vh", md: "calc(100vh - 133px)" }}
                        height={"fit-content"}
                    >
                        <Box
                            className="col-lg-4 col-12 p-4 pt-0 pe-lg-0  p-lg-3"
                            display={{
                                xs: selectedId !== null ? "none" : "block",
                                sm: "block",
                            }}
                            // border='1px solid red'
                            height="fit-contnet"
                        >
                            {/* ------------------------------------------------------------------------------------- Tasks ------------------------------------------------------------- */}
                            <Box
                                className="mt-4 h-100 w-100"
                                maxHeight="calc( 100vh - 50px - 130px)"
                                overflow="auto"
                            // border='2'}
                            >
                                {totalallocation.map((item: any, index: number) => (

                                    <Box className='border mb-3 task-main2'
                                        bgcolor={`${selectedId === index && `#E3DDD1`}`}
                                        key={index}
                                        borderRadius='20px' onClick={() => {
                                            selectcard(index);
                                        }}
                                        sx={{ cursor: 'pointer' }}
                                    >
                                        <Typography className='fw-bold px-3 pt-2 pb-1' borderBottom='1px solid #ccc'>{item.bundleName}-{index + 1}</Typography>
                                        <Box className='p-3'>
                                            {item?.allocations.map((card: any, index2: number) => (
                                                <Box

                                                    className='task-2 task-3 mb-3 flex-wrap'
                                                    bgcolor={`${selectedId === index && `#FFFFFF`}`}
                                                    border={
                                                        selectedId === index
                                                            ? "1px solid #ADB792"
                                                            : "1px solid #a3a3a3"
                                                    }
                                                    key={index2}

                                                >
                                                    <Box className="d-flex gap-2 align-items-center">
                                                        {/* <Avatar sx={{ height: '42px', width: '42px' }}>{totalallocation?.data[index].venueId.logoUrl}</Avatar> */}
                                                        <Avatar
                                                            src={card?.venueId?.logoUrl}
                                                            sx={{
                                                                height: "40px",
                                                                width: "42px",
                                                                img: {
                                                                    objectFit: "contain", // ensures the full image fits inside
                                                                },
                                                            }}
                                                        />

                                                        <Box>
                                                            <Box className='d-flex align-items-center'>

                                                                <Typography
                                                                    variant="subtitle1"
                                                                    fontWeight="bold"
                                                                // className={clsx("m-0 p-0", {
                                                                //     "text-white": selectedId === index,
                                                                // })}
                                                                >
                                                                    {card.venueId?.venueName ?? `${card?.clientEntityId?.entityName} - ${card?.differentiateKey}`}

                                                                </Typography>
                                                                <IconButton title='View Detail' onClick={(e) => { e.stopPropagation(); setViewBrief(card?.venueId?.venueDescription); handleReadBrief(); }} ><Info sx={{ fontSize: '18px', fill: "#ADB792 !important" }} /></IconButton>
                                                            </Box>
                                                            <Typography
                                                                variant="caption"
                                                                className='task-caption'
                                                            // className={clsx("task-caption", {
                                                            //     // "text-white": selectedId === index,
                                                            //     // "text-grey": selectedId !== index,
                                                            // })}
                                                            >
                                                                {card?.allocationPriceDisplay != "" ? card?.allocationPriceDisplay : "N/A"}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                    <Box>
                                                        <Typography
                                                            variant="body2"
                                                            className='text-end'
                                                        // className={clsx("text-end", {
                                                        //     "text-white": selectedId === index,
                                                        //     "text-grey": selectedId !== index,
                                                        // })}
                                                        >
                                                            {card?.distanceInKm && parseFloat(card?.distanceInKm).toFixed(2)}
                                                            {card?.distanceInKm ? "km" : ""}
                                                        </Typography>
                                                        <Typography
                                                            variant="caption"
                                                            className='px-3 bg-second py-1'
                                                            // className={clsx("px-3 py-1", {
                                                            //     "text-white": selectedId === index,
                                                            //     "text-grey": selectedId !== index,
                                                            // })}
                                                            borderRadius="8px"
                                                        >
                                                            {card.venueId?.clientEntityId?.entityTypeId?.entityTypeName ?? card?.clientEntityId?.entityTypeId?.entityTypeName}
                                                        </Typography>
                                                    </Box>
                                                    <Box className='d-flex col-12 mt-1 align-items-center justify-content-between'>
                                                        <Typography fontSize='12px'>{card?.allocationClientGroup}</Typography>
                                                        <Typography fontSize='12px'>Postcode: {card?.venueId?.postalCode ?? card?.clientEntityId?.postalCode}</Typography>
                                                    </Box>
                                                    <Box>
                                                    </Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                        <Box className="col-lg-8 col-12 p-3">
                            {selectedId !== null && totalallocation[selectedId] && (
                                <>

                                    <Box
                                        className="h-100 d-flex flex-md-row flex-column"
                                        border={{ xs: "none", sm: "1px solid #a3a3a3" }}
                                        width={(totalallocation[selectedId]?.isNeedToSelectDate || !isTransport) ? '100%' : 'fit-content'}
                                        borderRadius="10px"
                                    >
                                        <IconButton
                                            className="w-100 justify-content-start d-flex d-md-none"
                                            onClick={() => {
                                                setSelectedId(null);
                                            }}
                                        >
                                            <WestOutlined fontSize="medium" />
                                        </IconButton>

                                        <Box width='100%'>
                                            <Box className='my-2'>
                                                <Stepper key={steps} connector={<ColorlibConnector />} activeStep={activeStep} alternativeLabel>
                                                    {(totalallocation[selectedId]?.isNeedToSelectDate || !isTransport) && (steps.map((label) => (
                                                        <Step key={label}>
                                                            <StepLabel StepIconComponent={ColorlibStepIcon}></StepLabel>
                                                        </Step>
                                                    )))}
                                                </Stepper>
                                            </Box>
                                            {activeStep !== steps.length ?
                                                // (    <React.Fragment>
                                                //         <Typography sx={{ mt: 2, mb: 1 }}>
                                                //             All steps completed - you&apos;re finished
                                                //         </Typography>
                                                //         <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                                //             <Box sx={{ flex: '1 1 auto' }} />
                                                //             <Button onClick={handleReset}>Reset</Button>
                                                //         </Box>
                                                //     </React.Fragment>
                                                // ) : 
                                                (
                                                    <React.Fragment>
                                                        <Box className='d-flex flex-column' height='calc(100% - 75px)'>
                                                            {(totalallocation[selectedId]?.isNeedToSelectDate || !isTransport) && (
                                                                <Box width='100%' borderBottom={'1px solid #ccc'} className='p-2' sx={{ display: 'flex', flexDirection: 'row' }}>
                                                                    <Button
                                                                        className='bg-second text-light button-secondary-outlined px-4 py-1'
                                                                        color="inherit"
                                                                        disabled={activeStep === 0}
                                                                        onClick={() => { handleBack(totalallocation[selectedId]?.allocations[activeStep - 1]?.allocationId) }}
                                                                        sx={{ mr: 1 }}
                                                                    >
                                                                        Back
                                                                    </Button>
                                                                    <Box sx={{ flex: '1 1 auto' }} />

                                                                </Box>
                                                            )}
                                                            <Box className='d-flex' flexWrap={{ xs: "wrap", lg: 'nowrap' }} maxWidth={'100%'}>
                                                                {(totalallocation[selectedId]?.isNeedToSelectDate || !isTransport) && (
                                                                    <Box className="col-md-6 col-xl-7 col-12 p-3">
                                                                        <Box className="d-flex gap-3">
                                                                            <Box className="d-flex gap-2">
                                                                                <Avatar
                                                                                    src={
                                                                                        totalallocation[selectedId]?.allocations[activeStep]?.venueId?.logoUrl
                                                                                    }
                                                                                    sx={{
                                                                                        height: "40px",
                                                                                        width: "42px",
                                                                                        img: {
                                                                                            objectFit: "contain",
                                                                                        },
                                                                                    }}
                                                                                />

                                                                                <Box>
                                                                                    <Typography
                                                                                        variant="subtitle1"
                                                                                        fontWeight="bold"
                                                                                        className="m-0 p-0"
                                                                                    >
                                                                                        {
                                                                                            totalallocation[selectedId]?.allocations[activeStep]?.venueId?.venueName ?? `${totalallocation[selectedId]?.allocations[activeStep]?.venueId?.clientEntityId?.entityName} - ${totalallocation[selectedId]?.allocations[activeStep]?.differentiateKey}`
                                                                                        }

                                                                                    </Typography>
                                                                                    <Typography
                                                                                        variant="caption"
                                                                                        className="px-3 py-1 bg-second"
                                                                                        borderRadius="8px"

                                                                                    >
                                                                                        {
                                                                                            totalallocation[selectedId]?.allocations[activeStep]
                                                                                                ?.venueId?.clientEntityId?.entityTypeId?.entityTypeName ??
                                                                                            totalallocation[selectedId]?.allocations[activeStep]?.clientEntityId?.entityTypeId?.entityTypeName
                                                                                        }
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                            <Typography variant="subtitle1" className="text-main">
                                                                                {
                                                                                    totalallocation[selectedId]?.allocations[activeStep]?.allocationPriceDisplay !== '' ? totalallocation[selectedId]?.allocations[activeStep]?.allocationPriceDisplay : "N/A"
                                                                                }
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box className="my-2">
                                                                            <Typography variant="subtitle2" className="text-grey">
                                                                                Address
                                                                            </Typography>
                                                                            <Typography variant="subtitle1" fontWeight="bold">
                                                                                {totalallocation[selectedId]?.allocations[activeStep]?.venueId?.address} {totalallocation[selectedId]?.allocations[activeStep]?.venueId?.city} {totalallocation[selectedId]?.allocations[activeStep]?.venueId?.state} n{totalallocation[selectedId]?.allocations[activeStep]?.venueId?.postalCode}
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box className="my-2">
                                                                            <Typography variant="subtitle2" className="text-grey">
                                                                                Postcode
                                                                            </Typography>
                                                                            <Typography variant="subtitle1" fontWeight="bold">
                                                                                {totalallocation[selectedId]?.allocations[activeStep]?.venueId?.postalCode}
                                                                            </Typography>
                                                                        </Box>
                                                                        {totalallocation[selectedId]?.allocations[activeStep]?.venueId?.clientEntityId?.entityName != "Liquor ID" && (
                                                                            <Box className="my-2">
                                                                                <Typography variant="caption" className="text-grey">
                                                                                    Trading Hours
                                                                                </Typography>
                                                                                <Typography variant="subtitle2" fontWeight="bold">
                                                                                    {totalallocation[selectedId]?.allocations[activeStep]?.venueId?.tradingHours}
                                                                                </Typography>
                                                                            </Box>
                                                                        )}
                                                                        <Box className="my-2">
                                                                            <Typography variant="subtitle2" className="text-grey">
                                                                                Website
                                                                                {/* Active allocation = {totalallocation[selectedId]?.allocations[activeStep]?.allocationId} */}
                                                                            </Typography>
                                                                            <Typography variant="subtitle1" fontWeight="bold">
                                                                                <a target="__blank" href={totalallocation[selectedId]?.allocations[activeStep]?.venueId?.websiteURL}>{totalallocation[selectedId]?.allocations[activeStep]?.venueId?.websiteURL}</a>
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box className="my-2">
                                                                            <Typography variant="caption" className="text-grey">
                                                                                Special Comments
                                                                            </Typography>
                                                                            <Typography variant="subtitle2" fontWeight="bold">
                                                                                {totalallocation[selectedId]?.allocations[activeStep]?.specialComment}
                                                                            </Typography>
                                                                        </Box>
                                                                        <Box className="my-2">
                                                                            <Button
                                                                                variant='outlined'
                                                                                fullWidth
                                                                                className="button-secondary-outlined mt-3"
                                                                                // onClick={handleDialogOpen}
                                                                                onClick={() => handleReadBrief()}
                                                                            >
                                                                                Read Brief {totalallocation[selectedId]?.allocations[activeStep]?.venueId?.locationType}
                                                                            </Button>
                                                                        </Box>
                                                                    </Box>
                                                                )}
                                                                {window.innerWidth > 767 && (totalallocation[selectedId]?.isNeedToSelectDate || !isTransport) && (
                                                                    <Divider
                                                                        orientation="vertical"
                                                                        sx={{
                                                                            display: { xs: "none", sm: "block" },
                                                                            borderColor: "#a3a3a3",
                                                                        }}
                                                                    />
                                                                )}

                                                                <form onSubmit={formik.handleSubmit}>

                                                                    <Box className="d-flex flex-column w-100 p-3" maxWidth={'400px'}>
                                                                        <Box className='w-100' sx={{ maxWidth: '100%' }}>
                                                                            <FormControl
                                                                                fullWidth

                                                                                error={formik.touched.selectedVisitDate && Boolean(formik.errors.selectedVisitDate)}
                                                                            >
                                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                    <StaticDatePicker
                                                                                        key={selectedmonth.toString()}
                                                                                        value={
                                                                                            formik.values.selectedVisitDate
                                                                                                ? dayjs(formik.values.selectedVisitDate)
                                                                                                : null
                                                                                        }
                                                                                        onChange={(newValue) => {
                                                                                            formik.setFieldValue(
                                                                                                "selectedVisitDate",
                                                                                                newValue
                                                                                                    ? newValue.format("YYYY-MM-DD")
                                                                                                    : ""
                                                                                            );
                                                                                            const data2 = {
                                                                                                allocationId: totalallocation[selectedId]?.allocations[activeStep]?.allocationId,
                                                                                                clientEntityId: totalallocation[selectedId]?.allocations[activeStep]?.venueId?.clientEntityId?.clientEntityId,
                                                                                                venueId: totalallocation[selectedId]?.allocations[activeStep]?.venueId?.venueId,
                                                                                                jobMonth: totalallocation[selectedId]?.allocations[activeStep]?.jobMonth,
                                                                                                jobYear: totalallocation[selectedId]?.allocations[activeStep]?.jobYear,
                                                                                                userId: userData?.userId,
                                                                                            };
                                                                                            (!isTransport) && newValue && allocationCriteria?.shouldBeDifferentVisitTimeFromPreviousAllocation && handleCallAnotherCriteria(data2, allocationCriteria?.isNeedToHideWeekend, allocationCriteria?.isNeedToHideNonWeekend)
                                                                                        }}
                                                                                        referenceDate={
                                                                                            selectedmonth
                                                                                                ? dayjs(selectedmonth, "YYYY-MM")
                                                                                                : dayjs(`${totalallocation[selectedId]?.allocations[activeStep]?.jobYear}-${String(totalallocation[selectedId]?.allocations[activeStep]?.jobMonth).padStart(2, "0")}`, "YYYY-MM")

                                                                                        }

                                                                                        // minDate={
                                                                                        //    !totalallocation[selectedId]?.isNeedToSelectDate && totalallocation[selectedId]?.bundleMinDate
                                                                                        //         ? dayjs(selectedmonth, "YYYY-MM").date(totalallocation[selectedId]?.bundleMinDate) // set day
                                                                                        //         : dayjs(selectedmonth, "YYYY-MM").startOf("month")
                                                                                        // }
                                                                                        minDate={(() => {
                                                                                            const today = dayjs().startOf("day");

                                                                                            const isNeedDate = totalallocation?.[selectedId]?.isNeedToSelectDate;
                                                                                            const bundleMin = totalallocation?.[selectedId]?.bundleMinDate;

                                                                                            // Apply bundle logic only when condition is true
                                                                                            if ((!isNeedDate && isTransport) && bundleMin) {
                                                                                                // console.log("Hello")
                                                                                                const bundleMinDate = dayjs(selectedmonth, "YYYY-MM")
                                                                                                    .date(bundleMin)
                                                                                                    .startOf("day");
                                                                                                // Ensure not less than today
                                                                                                return dayjs.max(today, bundleMinDate);
                                                                                            }

                                                                                            // Default: today
                                                                                            return today;
                                                                                        })()}
                                                                                        maxDate={
                                                                                            (!totalallocation[selectedId]?.isNeedToSelectDate && isTransport) && totalallocation[selectedId]?.bundleMaxDate
                                                                                                ? dayjs(selectedmonth, "YYYY-MM").date(totalallocation[selectedId]?.bundleMaxDate) // set day
                                                                                                : dayjs(selectedmonth, "YYYY-MM").endOf("month")
                                                                                        }
                                                                                        // maxDate={(() => {
                                                                                        //     const value =
                                                                                        //         (!totalallocation[selectedId]?.isNeedToSelectDate || isTransport) &&
                                                                                        //             totalallocation[selectedId]?.bundleMaxDate
                                                                                        //             ? dayjs(selectedmonth, "YYYY-MM").date(
                                                                                        //                 totalallocation[selectedId]?.bundleMaxDate
                                                                                        //             )
                                                                                        //             : dayjs(selectedmonth, "YYYY-MM").endOf("month");

                                                                                        //     console.log("Calculated maxDate:", value?.format("YYYY-MM-DD"));
                                                                                        //     return value;
                                                                                        // })()}
                                                                                        shouldDisableDate={(date) => {

                                                                                            return (totalallocation[selectedId]?.isNeedToSelectDate || !isTransport) && (

                                                                                                // totalallocation[selectedId]?.allocations[activeStep]?.venueId?.locationType === 'region'
                                                                                                //     ?
                                                                                                //     shouldDisableDate(
                                                                                                //         date,
                                                                                                //         totalallocation[selectedId]?.allocations[activeStep]?.jobMonth,
                                                                                                //         totalallocation[selectedId]?.allocations[activeStep]?.jobYear,
                                                                                                //         allocationCriteria?.regionMinDate,
                                                                                                //         allocationCriteria?.regionMaxDate,
                                                                                                //         allocationCriteria?.regionVisitDaysInformation
                                                                                                //     )
                                                                                                //     :
                                                                                                shouldDisableDate(
                                                                                                    date,
                                                                                                    totalallocation[selectedId]?.allocations[activeStep]?.jobMonth,
                                                                                                    totalallocation[selectedId]?.allocations[activeStep]?.jobYear,
                                                                                                    totalallocation[selectedId]?.allocations[activeStep]?.minDate,
                                                                                                    totalallocation[selectedId]?.allocations[activeStep]?.maxDate,
                                                                                                    totalallocation[selectedId]?.allocations[activeStep]?.visitDaysInformation
                                                                                                    // totalallocation?.data[selectedId]?.allocations[activeStep]?.minDate,
                                                                                                    // totalallocation?.data[selectedId]?.allocations[activeStep]?.maxDate,
                                                                                                    // totalallocation?.data[selectedId]?.allocations[activeStep]?.visitDaysInformation
                                                                                                )
                                                                                            )
                                                                                        }
                                                                                        }

                                                                                        sx={{
                                                                                            "& .MuiPickersCalendarHeader-switchViewButton":
                                                                                            {
                                                                                                // display: "none",
                                                                                            },
                                                                                            "& .MuiPickersArrowSwitcher-root": {
                                                                                                // display: "none",
                                                                                            },

                                                                                            "& .MuiPickersCalendarHeader-labelContainer":
                                                                                            {
                                                                                                pointerEvents: "none",
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </LocalizationProvider>
                                                                                {formik.touched.selectedVisitDate && formik.errors.selectedVisitDate && (
                                                                                    <FormHelperText>{formik.errors.selectedVisitDate}</FormHelperText>
                                                                                )}
                                                                            </FormControl>
                                                                            {/* <ErrorMessage
                                                                                name="selectedVisitDate"
                                                                                component="div"
                                                                                className="error"
                                                                            /> */}
                                                                            <FormControl fullWidth sx={{ maxWidth: '100%' }}>
                                                                                <InputLabel
                                                                                    id="demo-simple-select-label"
                                                                                    shrink={false}
                                                                                >
                                                                                    {" "}
                                                                                    <span>
                                                                                        Visiting Time{" "}
                                                                                        <sup>
                                                                                            <i className="fa-solid fa-star-of-life star"></i>
                                                                                        </sup>
                                                                                    </span>
                                                                                </InputLabel>
                                                                                <Select
                                                                                    className='w-100'
                                                                                    sx={{ maxWidth: "100%", overflow: 'hidden' }}
                                                                                    labelId="demo-simple-select-label"
                                                                                    aria-placeholder="Select the Time"
                                                                                    value={formik.values.selectedVisitTime}
                                                                                    onChange={(e) =>
                                                                                        formik.setFieldValue(
                                                                                            "selectedVisitTime",
                                                                                            e.target.value
                                                                                        )
                                                                                    }
                                                                                    MenuProps={{
                                                                                        disablePortal: false, // Ensures dropdown is rendered inside the parent DOM
                                                                                    }}
                                                                                >
                                                                                    {filtervalue?.map((option, index) => (
                                                                                        <MenuItem
                                                                                            key={index}
                                                                                            value={option.visitTimeId}
                                                                                        >
                                                                                            {option.visitTimeInformation}
                                                                                        </MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                                {formik.touched.selectedVisitTime && formik.errors.selectedVisitTime && (
                                                                                    <FormHelperText className='text-danger'>{formik.errors.selectedVisitTime}</FormHelperText>
                                                                                )}
                                                                            </FormControl>

                                                                        </Box>
                                                                        <Button
                                                                            type={(allocationCriteria?.isNewBriefSetup && allocationCriteria?.isQuizRequired) ? "button" : 'submit'}
                                                                            className="button-primary mt-4"
                                                                            fullWidth
                                                                            onClick={async () => {
                                                                                if (!formik.values.selectedVisitDate || !formik.values.selectedVisitTime) {
                                                                                   await  formik.setTouched({
                                                                                        selectedVisitDate: true,
                                                                                        selectedVisitTime: true,
                                                                                    });
                                                                                    toast.error('Please select both date and time')
                                                                                    return
                                                                                }
                                                                                if (allocationCriteria?.isNewBriefSetup && allocationCriteria?.isQuizRequired) {
                                                                                    setOpenInfo(true)
                                                                                    await getBrief(
                                                                                        totalallocation[selectedId]?.allocations[activeStep]?.venueId?.venueId,
                                                                                        totalallocation[selectedId]?.allocations[activeStep]?.venueId?.clientEntityId?.clientEntityId
                                                                                    );
                                                                                    if (!allocationCriteria?.isNewBriefSetup && allocationCriteria?.isQuizRequired) {
                                                                                        await handleOpenQuiz(
                                                                                            totalallocation[selectedId]?.allocations[activeStep]?.venueId?.clientEntityId?.clientEntityId,
                                                                                            totalallocation[selectedId]?.allocations[activeStep]?.venueId?.venueId,
                                                                                            true
                                                                                        );
                                                                                    }
                                                                                    else {
                                                                                        setOpenInfo(true)
                                                                                        // setOpenNewBriefDialog(true)
                                                                                    }
                                                                                }
                                                                            }}
                                                                        >
                                                                            {allocationCriteria?.isQuizRequired ? "Take Quiz" : activeStep === steps.length - 1 ? 'Apply Task' : 'Next'}
                                                                        </Button>

                                                                    </Box>

                                                                    <div className="full-dilaog">
                                                                        <Dialog open={OpenNewBriefDialog} className="full-dilaog d-flex flex-column" fullScreen>
                                                                            <DialogContent className="p-0" sx={{ flex: 1 }}>
                                                                                {newBrief?.data && (<ReadBrief isVewOnly={false} handleClose={() => setOpenNewBriefDialog(false)} newBrief={newBrief?.data} title={newBrief?.mainTitle} selecetedAllocation={totalallocation[selectedId]?.allocations[activeStep]} setSelectedOptions={setSelectedOptions} setIsQuizSubmitted={setIsQuizSubmitted} selectedOptions={selectedOptions} QuizList={QuizList} handleOpenQuiz={handleOpenQuiz} submitform={formik.handleSubmit} />)}
                                                                            </DialogContent>
                                                                        </Dialog>
                                                                    </div>
                                                                </form>

                                                            </Box>
                                                        </Box>
                                                    </React.Fragment>
                                                ) :
                                                (
                                                    <Box
                                                        className="w-100 d-flex align-items-start pt-5 justify-content-center"
                                                        height={"calc(100vh - 133px)"}
                                                    >
                                                        <Box>
                                                            {/* <Box
                                                                component="img"
                                                                className="mx-auto d-block"
                                                                src={sad}
                                                                height="128px"
                                                                alt="sad emoji"
                                                            /> */}
                                                            <Typography
                                                                className="text-center mt-3 fw-bold text-main"
                                                                variant="h4"
                                                            >
                                                                Your Form has been Submitted
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                )}
                                        </Box>

                                    </Box>
                                </>
                            )}
                        </Box>
                    </Box>
                )
                    : (
                        <Box
                            className="w-100 d-flex align-items-start pt-5 justify-content-center"
                            height={"calc(100vh - 133px)"}
                        >
                            <Box>
                                <Typography
                                    className="text-center mt-3 fw-bold text-main"
                                    variant="h4"
                                >
                                    All bundle tasks are currently filled. Check back soon.
                                </Typography>
                                <Typography
                                    className="text-center mt-3 fw-bold text-main"
                                    variant="h6"
                                >
                                    Please click on a <span style={{ cursor: 'pointer', color: '#ADB792', textDecoration: 'underline' }} onClick={() => { setOpenPicker(true) }}> month</span> to view future listed jobs, <span style={{ cursor: 'pointer', color: '#ADB792', textDecoration: 'underline' }} onClick={() => { setOpenFilter(true) }}> expand your search </span> radius beyond {formValues?.range} km, or explore our <span style={{ cursor: 'pointer', color: '#ADB792', textDecoration: 'underline' }} onClick={() => { setAlignment('individual') }}> individual tasks.</span> </Typography>
                            </Box>
                        </Box>
                    )
                }
            </Box>
            <Dialog open={OpenDialog}>
                <DialogContent>
                    {selectedId !== null && (totalallocation[selectedId]?.allocations[activeStep] || newBrief) ? (
                        <>
                            <Box className='d-flex align-items-center justify-content-between mb-2'>
                                <Typography>{newBrief?.data[0]?.title}</Typography>
                                <IconButton
                                    className="ms-auto d-block"
                                    onClick={() => {
                                        handleDialogClose();
                                    }}
                                >
                                    <CancelOutlined className="fd-2" />
                                </IconButton>
                            </Box>
                            <Box
                                overflow="auto"
                                dangerouslySetInnerHTML={{
                                    __html:
                                        newBrief?.data?.[0]?.description || totalallocation[selectedId]?.allocations[activeStep].venueId
                                            ?.venueDescription || "",
                                }}
                            />
                            <Button
                                className="button-primary mx-auto py-2 px-4 d-block"
                                onClick={() => {
                                    handleDialogClose();
                                }}
                            >
                                Continue
                            </Button>
                        </>
                    ) : (
                        <Typography variant="subtitle1">No Data Found</Typography>
                    )}
                </DialogContent>
            </Dialog>
            <div className="full-dilaog">
                <Dialog open={OpenNewBriefReadDialog} className="full-dilaog d-flex flex-column" fullScreen>
                    {/* <DialogActions className="justify-content-end w-100">
                                            <IconButton
                                              className="ms-auto d-block m-0 p-0"
                                              onClick={() => {
                                                // handleBriefDialogClose();
                                                setOpenNewBriefDialog(false)
                                                setNewBrief(null)
                                              }}
                                            >
                                              <CancelOutlined className="fd-2" />
                                            </IconButton>
                                          </DialogActions> */}
                    <DialogContent className="p-0" sx={{ flex: 1 }}>
                        {newBrief?.data ? (<ReadBrief isVewOnly={true} handleClose={() => { setOpenNewBriefReadDialog(false) }} newBrief={newBrief?.data} title={newBrief?.mainTitle} selecetedAllocation={totalallocation[selectedId]?.allocations[activeStep]} setSelectedOptions={setSelectedOptions} setIsQuizSubmitted={setIsQuizSubmitted} selectedOptions={selectedOptions} QuizList={QuizList} handleOpenQuiz={handleOpenQuiz} submitform={formik.handleSubmit} />) : (<>Not FOund</>)}
                    </DialogContent>
                </Dialog>
            </div>
            <Dialog open={openInfo}>
                <DialogContent>
                    <Typography variant="h6">
                        Before applying for this task, please read the brief and complete a short knowledge check. Once you've passed, you won't need to take it again unless the brief changes.
                    </Typography>
                    <Box className='d-flex align-items-center gap-2 justify-content-center'>
                        <Button className="button-primary-outlined py-1 px-3" variant="outlined" onClick={() => { setOpenInfo(false) }}>Cancel</Button>
                        <Button className="button-primary py-1 px-3" onClick={() => { setOpenInfo(false); setOpenNewBriefDialog(true) }}>Continue</Button>
                    </Box>
                </DialogContent>
            </Dialog>
            {loading && <Loading />}
        </Box>
    )
}

export default BulkAllocation
